module.exports = __webpack_public_path__ + "zapier-logo.png?0c2a96e86b68d9c69b6b8fa4e0301a68";